import { useEffect, useState } from "react";

export function useImagePreload(urls = []) {
  const [loadedCount, setLoadedCount] = useState(0);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!urls || urls.length === 0) {
      setLoadedCount(0);
      setHasError(false);
      return;
    }

    let isCancelled = false;
    setLoadedCount(0);
    setHasError(false);

    urls.forEach((url) => {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        if (!isCancelled) {
          setLoadedCount((prev) => prev + 1);
        }
      };
      img.onerror = () => {
        if (!isCancelled) {
          setHasError(true);
          setLoadedCount((prev) => prev + 1);
        }
      };
    });

    return () => {
      isCancelled = true;
    };
  }, [urls]);

  const allLoaded = urls.length > 0 ? loadedCount === urls.length : true;

  return {
    loaded: allLoaded,
    error: hasError,
  };
}
